/**
* @description
*   TheImageTool.vue of WeTrade
*/
<template>
  <Donut v-if="processing" />
  <span v-else @click="upload" class="df-middle">
      <Icon name="picture" class="mr-8" />
      <t path="postpublish_4" custom #="{td}">{{ td || 'Image' }}</t>
    </span>
</template>

<script lang="ts">
import { uploadImg } from '@/modules/community/communities/community'
import Donut from 'common/loading/Donut.vue'
import { defineComponent, shallowRef } from 'vue'
import Icon from '@/components/Icon.vue'

export default defineComponent(
  {
    name: 'TheImageTool',
    components: { Donut, Icon },
    emits: ['use'],
    setup (props, ctx) {
      const processing = shallowRef(false)

      const upload = async () => {
        processing.value = true
        const path = await uploadImg(false)
          .finally(() => {
            processing.value = false
          })
        if (path) ctx.emit('use', path)
      }

      return {
        processing,
        upload,
      }
    },
  },
)
</script>
